// Overview-page strings, externalized for future i18n. The widget owns the
// dictionary because it composes every entity component that renders text.
// Pages/overview pulls from this same module so a single edit propagates.
//
// Keeping the dictionary as a flat constant (not a hook / context) keeps it
// tree-shakeable: only the keys actually imported by a component end up in
// the bundle.

export const OVERVIEW_STRINGS = {
  pageTitle: "Overview",
  selectorLabel: "Active community",
  notificationsLabel: "Notifications",
  notificationsAria: "Open notifications",
  health: {
    cardTitle: "Health",
    label: "Health",
    captionLastUpdated: "Last updated",
    upgradeCta: "Upgrade to Pro for the full breakdown",
  },
  metrics: {
    membersLabel: "Members",
    membersHint: "Total tracked",
    dauLabel: "Active members",
    dauHint: "Last full hour",
    messagesLabel: "Messages (24h)",
    messagesHint: "Sum of last 7 days ÷ 7",
    growthLabel: "Net growth (24h)",
    growthHint: "Joins minus leavers",
  },
  trend: {
    title: "Activity (last 7 days)",
    empty: "No activity yet — check back tomorrow",
  },
  topPosts: {
    title: "Top posts",
    subtitle: "Highest engagement in the last 7 days",
    empty: "No posts yet — wait for the first activity.",
    reactions: "reactions",
    replies: "replies",
  },
  empty: {
    title: "Collecting your community's first hour of data…",
    body: "Once we have an hour of messages, the dashboard will populate. Add the bot to a chat and post a few messages to get started.",
  },
  noCommunity: {
    title: "No community connected yet",
    body: "Open the bot in Telegram and follow the prompts to add your first community.",
  },
  loading: "Loading dashboard…",
  errorTitle: "We couldn't load your dashboard",
  errorBodyDefault: "Something went wrong fetching your community data.",
  retry: "Retry",
} as const;

export type OverviewStrings = typeof OVERVIEW_STRINGS;
